import {UiApp} from "./components/front/UiApp";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {DateTime} from "mu-js-utils/lib/DateTime";

// @ts-ignore
let uiApp: UiApp;

export const frontRouter = new MuRouter();
frontRouter.addRoute('newJournalActivitySetActivity', '/day-<day>/new-journal-activity/<activityId>',
    // @ts-ignore
    (ev) => uiApp.selectNewActivity(parseInt(ev.parameters.activityId))
);
frontRouter.addRoute('newJournalActivity', '/day-<day>/new-journal-activity', () => uiApp.openAddMenu());
frontRouter.addRoute('clientData', '/day-<day>/client-data', () => uiApp.openClientData());
frontRouter.addRoute('editJournalActivity', '/day-<day>/edit-journal-activity/<id>',
    // @ts-ignore
    (ev) => uiApp.editActivity(null, parseInt(ev.parameters.id)));
frontRouter.addRoute('day', '/day-<day>', () => uiApp.closePanel());
frontRouter.addRoute('home', '/', () => frontRouter.replaceUpdate('day', { day: DateTime.format(new Date(), 'Y-m-d') }));

frontRouter.persistentKeys.push('day');

export function setupFrontRouter(currentUiApp: UiApp)
{
    uiApp = currentUiApp;
    frontRouter.pathPrefix = currentUiApp.urlPrefix;
}

